﻿import { Component, OnInit,ViewChild,ElementRef } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FormGroup, FormControl, NgForm, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Constants } from '../../../../_utils/Constants';
import { APILoginService } from '../../_services/login/API-login';
//import { LoginComponent } from '../login/login.component';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import * as crypto from 'crypto-js';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';
import { APIConstants } from '../../../../_config/restapis';
import { APIEncryptionDecryption } from '../../_services/CommonService/API-Common-Service';
import { APIDndRegistrationDetails } from '../../_services/dnd-registration-details/API-dnd-registration-details';



@Component({
  selector: 'app-subscriber-login',
  templateUrl: './subscriber-login.component.html',
  styleUrls: ['./subscriber-login.component.css']
})
export class SubscriberLoginComponent implements OnInit {
// @ViewChild('#GenerateOTP') button:ElementRef;
 
  form: FormGroup;
  commonLoginForm: FormGroup;
  submitted: boolean = false;
  public role: any;
  public entityType: any;
  public user: any;
  public loginFlag = false;
  OTP_clicked: boolean  = false;
  public virtual_id: any;
  homeRole: boolean = false;
  mobilenumsplitted: any;
  emailsplitted: any;

   hide = true;
   public msg:any;
   public msg1:any;
   public msg2:any;
   public msg3:any;

  

  constructor(private formBuilder: FormBuilder,
    private router: Router,
    private db: $DBManagerService,
    private ls: APILoginService,
    private $modal: $ModalManagerService,
    private encryDecry : APIEncryptionDecryption,
    private evt: $BroadcastManagerService,
    private _call: APIDndRegistrationDetails,
    ) { }
  
  ngOnInit() {
    this.commonLoginForm = this.formBuilder.group({
      userName: ['', [Validators.required]],
      password: ['', [Validators.required]],
      otp: ['', [Validators.required]],
      phoneNumber: ['', [Validators.required, Validators.pattern("[1-9][0-9]{9}"), Validators.minLength(10)]],
      role: ['', [Validators.required]]
    }); 
 
    this.db.clearDB();
    this.evt.emit({ 'click': 'HEADER_EVENT' });
    this.evt.emit({ 'click': 'HEADER_EVENT_' });   
  }
  
  get f() {
    return this.commonLoginForm.controls;
  }

  onChange(role) {
    console.log("role :", role);
    this.role = role;
  }
 hideClick(){
	 this.hide =! this.hide ;
 }




 downloadPrefFAQ(){
   this._call.downloadPrefFAQ()
   .subscribe((r) =>
   console.log("Downloaded Successfully")
   )
 }
  generateOTP(val) {    
    if(this.f.phoneNumber.value == undefined || this.f.phoneNumber.errors ) {     
      console.log("Phone number validation: ", this.f.phoneNumber.errors);
      return;
    }
    else {

       let mobilnumber = this.commonLoginForm.get("phoneNumber").value;  
	   this.ls.send_OTP(mobilnumber).subscribe((r) =>   
	   {
     console.log(r);
    // this.msg1 = false;

		 if(r.status == "null"){
     this.msg = true;
     this.$modal.errorModal({
        title: 'Subscriber Login',
        msg: 'Preference Registration is Not Applicable for this Service Type through Portal. Please click on below link to proceed further.'     });
         }

     else if(r.status == "DetailsNotPresent"){
      this.msg = true;

      this.$modal.errorModal({
        title: 'Subscriber Login',
        msg: 'OTP verification cannot be initiated, since your Email ID & Contact Number are not available. Please write to 1515@tatatel.co.in to share these details with us. The information will get updated in systems within 24 hours.'

      }); 
     }
     else if(r.status == "All fields are invalid"){
      this.msg = true;

      this.$modal.errorModal({
        title: 'Subscriber Login',
        msg: 'All fields are invalid'

      }); 
     }
     
     else {
		 
		 if(val == "resend"){
			      this.$modal.successModal({
                   title: 'Subscriber Login',
                   msg: 'OTP has been resend successfully' 

               });  
		 }
		 
      this.OTP_clicked = true;
      this.msg = false;

       if(r.mobileno && r.email){
         this.msg1=true;
         this.mobilenumsplitted = r.mobileno;
         this.emailsplitted= r.email;

       }
       else if(r.mobileno){
        this.msg2=true;
        this.mobilenumsplitted =r.mobileno;
       }
       else if(r.email){
        this.msg3=true;
        this.emailsplitted= r.email;

      }
	  else if(r.status == "fail" && r.message == "Terminated"){
		  this.msg = true;
		  this.$modal.errorModal({
          title: 'Subscriber Login',
          msg: 'Preferences are Terminated for this number. Please approach TTL Customer care to proceed!'

         });
	  }
      else {
        console.log("error")
      }
    

	
     } 
	   }
	   )
       let mob = APIConstants.OTPDIR[mobilnumber];
       var otp = {
         "mobileNo": mob
       }

    }
  }
  resendOtp(){
	  
	 this.generateOTP("resend"); 
	 
  }
  
  
  
  
    onSubmit() {
    //console.log(" ..... ", this.f.userName.value, this.f.password.value, this.f.otp.value, this.f.phoneNumber.value);
	
	//console.log("opt===========>",this.f.otp.value);  
	
    if(this.f.phoneNumber.errors || this.f.otp.errors) {
     // console.log("OTP Validation: ", this.f.otp.errors);
      return ;
    }
    

    

    //For Subscriber Login
      this.entityType = "Subscriber";
      this.role = '4';
      let username = "Subscriber";
      this.db.set(Constants.SESSSION_STORAGE, Constants.USER_ROLE, this.entityType);
      this.db.set(Constants.SESSSION_STORAGE, Constants.MOBILE_NO, this.f.phoneNumber.value);


      // this.db.set(Constants.SESSSION_STORAGE, Constants.VIRTUAL_MOB_ID, encrypted_mob);
      let virtual_mobilenumber=crypto.SHA256(this.f.phoneNumber.value).toString();
       console.log("virtual id: in commonlogin ", virtual_mobilenumber);
      this.db.set(Constants.SESSSION_STORAGE, Constants.VIRTUAL_MOB_ID, virtual_mobilenumber);
      this.db.set(Constants.SESSSION_STORAGE, Constants.MOBILE_NO, this.f.phoneNumber.value);
      let mobilnumber = this.commonLoginForm.get("phoneNumber").value;

      var data = {
        "Entity_Type": this.entityType,
        "Entity_User_Name": this.f.phoneNumber.value,
        "Entity_Password": this.f.otp.value
      };
      let email = APIConstants.OTPDIR[mobilnumber];
	  
     /* if(this.f.otp.value == "9999"){
        let otp = this.f.otp.value;
        console.log("otp verified");
        this.loginFlag = true;
        this.homeRole = true;
        localStorage.setItem('currentUser', "Subscriber");
        this.db.set(Constants.SESSSION_STORAGE, Constants.LOGIN_FLAG, this.loginFlag);
        this.db.set(Constants.SESSSION_STORAGE, Constants.HOME_ROLE, this.homeRole);
       // console.log("login get inside verify :",this.db.get(Constants.SESSSION_STORAGE, Constants.LOGIN_FLAG));
        this.evt.emit({ 'click': 'HEADER_EVENT' });
        this.evt.emit({ 'click': 'HEADER_EVENT_' });
        var dataa = 
        {
          "otp": 9999,
          "notificationType" : "verifyOTP",
          "identifier": email
          };
        
       this.ls.otpNotification(dataa)
       .subscribe((r) => {
        /* this.$modal.successModal({
          title: 'Notification',
          msg: 'Otp has been verified'
        }); */
    /*  });
        this.router.navigateByUrl('/dnd-registration-details');
      } */
     // else{
      var verify = {
        "otp": this.f.otp.value,
        "mobileNo": mobilnumber
      }
      this.ls.verifyOtp(verify)
        .subscribe((r) => {
			if(r.message == "Time Expired")
			{
				this.loginFlag = false;
            this.db.set(Constants.SESSSION_STORAGE, Constants.LOGIN_FLAG, this.loginFlag);
            console.log("login get inside error :",this.db.get(Constants.SESSSION_STORAGE, Constants.LOGIN_FLAG));
          this.$modal.errorModal({
            title: 'Subscriber Login',
            msg: 'Authentication Error: Time Expired!'      
          });
			}
         else if (r.message == "OTP successfully verified") {         
            let otp = this.f.otp.value;
            console.log("otp verified");
            var data = 
            {
              "otp": otp,
              "notificationType" : "verifyOTP",
              "identifier": email
              };
            
           this.ls.otpNotification(data)
           .subscribe((r) => {
           /*  this.$modal.successModal({
              title: 'Notification',
              msg: 'Otp has been verified'
            }); */
           })
            this.loginFlag = true;
            this.homeRole = true;
            this.db.set(Constants.SESSSION_STORAGE, Constants.LOGIN_FLAG, this.loginFlag);
            this.db.set(Constants.SESSSION_STORAGE, Constants.HOME_ROLE, this.homeRole);
            //console.log("login get inside verify :",this.db.get(Constants.SESSSION_STORAGE, Constants.LOGIN_FLAG));
            this.evt.emit({ 'click': 'HEADER_EVENT' });
            this.evt.emit({ 'click': 'HEADER_EVENT_' });
            localStorage.setItem('currentUser', "Subscriber");
            this.router.navigateByUrl('/dnd-registration-details');
          }
          else{
            this.loginFlag = false;
            this.db.set(Constants.SESSSION_STORAGE, Constants.LOGIN_FLAG, this.loginFlag);
            //console.log("login get inside error :",this.db.get(Constants.SESSSION_STORAGE, Constants.LOGIN_FLAG));
          this.$modal.errorModal({
            title: 'Subscriber Login',
            msg: 'Authentication Error: Please Enter valid OTP!'
          });
        }
      
        })
      //}

    } 
    downloadPrivacyprocess(){
      let link =document.createElement('a');
      link.setAttribute('type', 'hidden');
      link.href = '../../../../../assets/Privacy Policy.pdf';
      link.download = 'Privacy Policy Process';
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
    downloadTermsprocess(){
      let link =document.createElement('a');
      link.setAttribute('type', 'hidden');
      link.href = '../../../../../assets/Terms of Use.pdf';
      link.download = 'Terms of Use Process';
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
  }



